import Dialog from "../../../General/ConfirmableDialog";
import React, { useState, useEffect } from "react";
import {
  DialogTitle,
  DialogContent,
  TextField,
  DialogActions,
  Button,
  Select,
  MenuItem,
} from "@mui/material";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import dayjs, { Dayjs } from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

interface AdditionalDetailsDialogProps {
  open: boolean;
  fieldLabel: string;
  onClose: () => void;
  onSubmit: (
    value: string,
    contactedDate?: string,
    contactMethod?: string
  ) => void;
}

const AdditionalDetailsDialog: React.FC<AdditionalDetailsDialogProps> =
  React.memo(({ open, fieldLabel, onClose, onSubmit }) => {
    const [localFieldValue, setLocalFieldValue] = useState("");
    const [contactedDate, setContactedDate] = useState<Dayjs | null>(null);
    const [contactMethod, setContactMethod] = useState("");
    useEffect(() => {
      if (!open) {
        setLocalFieldValue("");
        setContactMethod("");
        setContactedDate(null);
      }
    }, [open]);

    const handleSubmit = () => {
      const formattedDate = contactedDate
        ? dayjs(contactedDate).format("YYYY-MM-DD")
        : "";
      onSubmit(localFieldValue, formattedDate, contactMethod);
    };

    return (
      <Dialog open={open} onClose={onClose}>
        <DialogTitle>{fieldLabel}</DialogTitle>
        <DialogContent>
          {fieldLabel !== "Contact Method" && (
            <TextField
              autoFocus
              margin="dense"
              label={fieldLabel}
              type="text"
              fullWidth
              value={localFieldValue}
              onChange={(e) => setLocalFieldValue(e.target.value)}
            />
          )}
          {fieldLabel === "Contact Method" && (
            <Select
              value={contactMethod}
              margin="dense"
              fullWidth
              displayEmpty
              renderValue={(selected) =>
                selected ? (
                  selected
                ) : (
                  <span style={{ color: "#888" }}>Select Contact Method</span>
                )
              }
              onChange={(e) => setContactMethod(e.target.value)}
              aria-label="Contact Method"
            >
              <MenuItem value="" disabled>
                Select Contact Method
              </MenuItem>
              <MenuItem value="PHONE">Phone</MenuItem>
              <MenuItem value="EMAIL">Email</MenuItem>
              <MenuItem value="PHONE AND EMAIL">Phone and Email</MenuItem>
            </Select>
          )}

          {fieldLabel === "Contact Method" && (
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label="Contacted Date"
                value={contactedDate}
                onChange={(newDate) => setContactedDate(newDate)}
                slotProps={{ textField: { fullWidth: true } }}
              />
            </LocalizationProvider>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>Cancel</Button>
          <Button onClick={handleSubmit}>Submit</Button>
        </DialogActions>
      </Dialog>
    );
  });

export default AdditionalDetailsDialog;
